import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['name', 'form']

  connect () {
    // eslint-disable-next-line no-undef
    this.resizeNameObserver = new ResizeObserver(() => this.syncNameWidths())
    // eslint-disable-next-line no-undef
    this.resizeFormbserver = new ResizeObserver(() => this.syncFormWidths())

    this.nameTargets.forEach(el => this.resizeNameObserver.observe(el))
    this.formTargets.forEach(el => this.resizeFormbserver.observe(el))
  }

  disconnect () {
    this.resizeNameObserver.disconnect()
    this.resizeFormbserver.disconnect()
  }

  nameTargetConnected (element) {
    if (this.resizeNameObserver) {
      this.resizeNameObserver.observe(element)
    }
  }

  formTargetConnected (element) {
    if (this.resizeFormbserver) {
      this.resizeFormbserver.observe(element)
    }
  }

  syncNameWidths () {
    const INDENT_PER_LEVEL = 16

    this.nameTargets.forEach(el => {
      el.style.width = 'auto'
      el.style.minWidth = 'auto'
    })

    const items = this.nameTargets.map(el => {
      return { el, depth: parseInt(el.dataset.depth || 0), currentWidth: el.offsetWidth }
    })

    const maxDepth = Math.max(...items.map(item => item.depth))

    const maxWidth = Math.max(...this.nameTargets.map(el => el.offsetWidth))
    items.forEach(item => {
      const edge = (maxDepth - item.depth) * INDENT_PER_LEVEL
      const width = `${edge + maxWidth - item.depth}px`

      item.el.style.width = width
      item.el.style.minWidth = width
    })
  }

  syncFormWidths () {
    this.formTargets.forEach(el => {
      el.style.width = 'auto'
      el.style.minWidth = 'auto'
    })

    const maxWidth = Math.max(...this.formTargets.map(el => el.offsetWidth))

    this.formTargets.forEach(el => {
      const width = `${maxWidth}px`

      el.style.width = width
      el.style.minWidth = width
    })
  }
}
